"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsersList = UsersList;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _api = require("@focaltec-suite/api");
var _UserMenu = require("./UserMenu");
var _UserActivatePopup = require("./UserActivatePopup");
var _UserBlockPopup = require("./UserBlockPopup");
var _UserUnblockPopup = require("./UserUnblockPopup");
var _UserDeletePopup = require("./UserDeletePopup");
var _reactNumberFormat = require("react-number-format");
var _UserResetPasswordPopup = require("./UserResetPasswordPopup");
var _UserAssistantPopup = _interopRequireDefault(require("./UserAssistantPopup"));
var _UserSearchFilter = _interopRequireDefault(require("./UserSearchFilter"));
var _UserSearchFilter2 = require("./UserSearchFilter.hooks");
var _UsersExportableMenu = _interopRequireDefault(require("./UsersExportableMenu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function UsersList(_ref) {
  var paramTenantId = _ref.tenantId,
    _ref$subpath = _ref.subpath,
    subpath = _ref$subpath === void 0 ? 'edit' : _ref$subpath,
    paths = _ref.paths;
  var _a, _b, _c;
  var contextHistory = (0, _commons.useContextHistory)();
  var qs = (0, _reactRouterDom.useLocation)().search;
  var query = (0, _react.useMemo)(function () {
    return new URLSearchParams(qs);
  }, [qs]);
  var params = (0, _UserSearchFilter2.useUsersFilter)(query);
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var tenantId = (_b = (_a = access === null || access === void 0 ? void 0 : access.tenant) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : paramTenantId;
  var backButton = (0, _commons.useBackButton)(paramTenantId, contextHistory.previousPathname);
  var _useState = (0, _react.useState)('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    user = _useState6[0],
    setUser = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    activatePopup = _useState8[0],
    setActivatePopup = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    dialog = _useState10[0],
    setDialog = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedIds = _useState12[0],
    setSelectedIds = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedUsers = _useState14[0],
    setSelectedUsers = _useState14[1];
  var clearCallback = (0, _react.useCallback)(function () {
    return setData(undefined);
  }, []);
  var _usePagination = (0, _commons.usePagination)(clearCallback),
    page = _usePagination.page,
    pageSize = _usePagination.pageSize,
    onChangedPage = _usePagination.onChangedPage,
    onChangedPageSize = _usePagination.onChangedPageSize;
  var retrievePromise = (0, _react.useCallback)(function () {
    var offset = (0, _commons.getOffset)(page, pageSize);
    return (0, _api.listUsers)(Object.assign(Object.assign({}, params), {
      page: pageSize,
      offset: offset
    }), {
      tenantId: tenantId,
      access: access
    });
  }, [tenantId, page, pageSize, params, access]);
  var reload = (0, _react.useCallback)(function () {
    setData(undefined);
    setStatus('loading');
    retrievePromise().then(function (response) {
      setData(response);
      setStatus('loaded');
    })["catch"](function (error) {
      setStatus(error);
    });
  }, [retrievePromise]);
  (0, _react.useEffect)(reload, [reload]);
  var showDialog = function showDialog(dialog) {
    return function (user) {
      setUser(user);
      setDialog(dialog);
    };
  };
  var onBlocked = function onBlocked() {
    if (!user) return;
    user.status = 'blocked';
    feedbackContext.showSuccess((0, _core.translate)('users.block.success', user));
    setUser(undefined);
    setDialog(undefined);
  };
  var onUnblocked = function onUnblocked() {
    if (!user) return;
    user.status = 'active';
    feedbackContext.showSuccess((0, _core.translate)('users.unblock.success', user));
    setUser(undefined);
    setDialog(undefined);
  };
  var onDelete = function onDelete() {
    if (!user) return;
    reload();
    feedbackContext.showSuccess((0, _core.translate)('users.delete.success', user));
    setUser(undefined);
    setDialog(undefined);
  };
  var onResetedPassword = function onResetedPassword() {
    if (!user) return;
    feedbackContext.showSuccess((0, _core.translate)('users.reset_password.success', user));
    setUser(undefined);
    setDialog(undefined);
  };
  var onAssistantCreated = function onAssistantCreated(assistant, url) {
    (0, _api.beginAssistantSession)(assistant);
    window.location.href = url;
  };
  var onError = function onError(error) {
    feedbackContext.showError(error);
    setUser(undefined);
    setDialog(undefined);
  };
  var onCancel = function onCancel() {
    setUser(undefined);
    setDialog(undefined);
  };
  var showActivatePopup = function showActivatePopup(user) {
    setUser(user);
    setActivatePopup(true);
  };
  var hideActivatePopup = function hideActivatePopup() {
    setUser(undefined);
    setActivatePopup(false);
  };
  var onClicked = function onClicked(user) {
    contextHistory.pushRoute(paramTenantId ? "/tenants/".concat(paramTenantId, "/users/").concat(user.id, "/").concat(subpath) : "/users/".concat(user.id, "/").concat(subpath));
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.Pagination, {
    title: (0, _core.translate)('users.title'),
    subtitle: (_c = data === null || data === void 0 ? void 0 : data.tenant) === null || _c === void 0 ? void 0 : _c.name,
    icon: /*#__PURE__*/_react["default"].createElement(_commons.UsersIcon, null),
    page: page,
    pageSize: pageSize,
    count: data ? data.items.length : 0,
    total: data ? data.count : 0,
    onChangedPage: onChangedPage,
    onChangedPageSize: onChangedPageSize,
    backButton: backButton,
    buttons: [{
      variant: 'primary',
      text: (0, _core.translate)('buttons.add'),
      icon: /*#__PURE__*/_react["default"].createElement(_commons.AddIcon, null),
      path: paramTenantId ? context.fixPath("/tenants/".concat(paramTenantId, "/users/new")) : context.fixPath('/users/new'),
      available: context.isGrantedAny(['PUsersCreate', 'TUsersCreate'])
    }],
    ellipsisBuilder: function ellipsisBuilder() {
      var _a;
      return /*#__PURE__*/_react["default"].createElement(_UsersExportableMenu["default"], {
        params: params,
        reload: reload,
        selectedIds: selectedIds,
        selectedUsers: selectedUsers,
        tenantId: tenantId !== null && tenantId !== void 0 ? tenantId : '',
        total: (_a = data === null || data === void 0 ? void 0 : data.count) !== null && _a !== void 0 ? _a : 0
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_UserSearchFilter["default"], {
    query: query
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mx: -2,
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Divider, null), /*#__PURE__*/_react["default"].createElement(_commons.DataGrid, {
    items: data ? data.items : [],
    loading: status === 'loading',
    error: status instanceof Error ? status.message : undefined,
    empty: (0, _core.translate)('users.empty'),
    getId: function getId(user) {
      return user.id;
    },
    clickable: {
      onClick: onClicked
    },
    refreshable: {
      columnId: 'actions',
      onClick: reload
    },
    selectable: {
      selected: selectedIds,
      onChange: function onChange(ids, items) {
        setSelectedIds(ids);
        setSelectedUsers(items);
      }
    },
    columns: [{
      title: (0, _core.translate)('users.name'),
      converter: function converter(user) {
        return user.name;
      },
      id: 'name'
    }, {
      title: (0, _core.translate)('users.email'),
      converter: function converter(user) {
        return user.email;
      },
      id: 'email'
    }, {
      title: (0, _core.translate)('users.phone'),
      converter: function converter(user) {
        return user.phone ? /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.PatternFormat, {
          value: user.phone,
          format: (0, _commons.phoneFormat)(user.phone),
          displayType: "text",
          renderText: function renderText(text) {
            return /*#__PURE__*/_react["default"].createElement(_material.Typography, {
              variant: "body2"
            }, text);
          }
        }) : '---';
      },
      id: 'phone'
    }, {
      title: (0, _core.translate)('users.status.title'),
      converter: function converter(user) {
        return (0, _core.translate)("users.status.".concat(user.status));
      },
      id: 'status'
    }, {
      title: /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        size: "small",
        style: {
          visibility: 'hidden'
        },
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement(_commons.EllipsisIcon, null)),
      converter: function converter(user) {
        return /*#__PURE__*/_react["default"].createElement(_UserMenu.UserMenu, {
          key: user.id,
          user: user,
          tenantId: paramTenantId,
          paths: paths,
          onBlock: showDialog('block'),
          onUnblock: showDialog('unblock'),
          onDelete: showDialog('delete'),
          onAssistant: showDialog('assistant'),
          onResetPassword: showDialog('reset_password'),
          onActivated: showActivatePopup
        });
      },
      id: 'actions',
      fixed: 'right',
      width: 60,
      textAlign: 'center'
    }]
  })), user && activatePopup && /*#__PURE__*/_react["default"].createElement(_UserActivatePopup.UserActivatePopup, {
    user: user,
    onClose: hideActivatePopup
  }), user && dialog === 'block' && /*#__PURE__*/_react["default"].createElement(_UserBlockPopup.UserBlockPopup, {
    user: user,
    tenantId: tenantId,
    access: access,
    onCompleted: onBlocked,
    onError: onError,
    onCancelled: onCancel
  }), user && dialog === 'unblock' && /*#__PURE__*/_react["default"].createElement(_UserUnblockPopup.UserUnblockPopup, {
    user: user,
    tenantId: tenantId,
    access: access,
    onCompleted: onUnblocked,
    onError: onError,
    onCancelled: onCancel
  }), user && dialog === 'delete' && /*#__PURE__*/_react["default"].createElement(_UserDeletePopup.UserDeletePopup, {
    user: user,
    tenantId: tenantId,
    access: access,
    onCompleted: onDelete,
    onError: onError,
    onCancelled: onCancel
  }), user && dialog === 'reset_password' && /*#__PURE__*/_react["default"].createElement(_UserResetPasswordPopup.UserResetPasswordPopup, {
    user: user,
    tenantId: tenantId,
    access: access,
    onCompleted: onResetedPassword,
    onError: onError,
    onCancelled: onCancel
  }), user && dialog === 'assistant' && /*#__PURE__*/_react["default"].createElement(_UserAssistantPopup["default"], {
    user: user,
    tenantId: tenantId !== null && tenantId !== void 0 ? tenantId : '-',
    access: access,
    onCompleted: onAssistantCreated,
    onError: onError,
    onCancelled: onCancel
  }));
}